import { render, staticRenderFns } from "./WorkmanshipReport.vue?vue&type=template&id=d8823a80&"
import script from "./WorkmanshipReport.vue?vue&type=script&lang=js&"
export * from "./WorkmanshipReport.vue?vue&type=script&lang=js&"
import style0 from "./WorkmanshipReport.vue?vue&type=style&index=0&id=d8823a80&prod&lang=css&"
import style1 from "./WorkmanshipReport.vue?vue&type=style&index=1&id=d8823a80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports